import { useRef, useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import * as Yup from "yup";
import { useFormik } from "formik";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
    getPlanLead,
    setPlanLead,
    updatePlanLead,
    deletePlanLead,
    setDataNull2,
} from "../../store/order/slice";
import { deleteMaterial } from "../../store/materials/slice";
import ActionMenu from "../../components/ActionMenu";
import ModelDelete from "../../components/ModalDelete";
import { Toast } from "primereact/toast";
import "../../assets/scss/theme-base/ModalShowPlanLead.css";
import { Checkbox } from "primereact/checkbox";
import { formatQuantity } from "../../components/utils";
import ModalMaterials from "./ModalMaterial";
import { deleteManyRequest } from "../../store/processings/slice";
import { Paginator } from "primereact/paginator";

export const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};

function ModalShowPlanLead({ isShow, onHide, productId }) {
    const [showNewPlanFields, setShowNewPlanFields] = useState(false);
    const toast = useRef(null);
    const [modalDelete, setModalDelete] = useState(false);
    const [rowData, setRowData] = useState();
    const [isEditMode, setIsEditMode] = useState(false);
    const [checked, setChecked] = useState(false);
    const [openModalUpdate, setOpenModalUpdate] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const dispatch = useDispatch();
    const {
        planLeadData,
        updatePlanLeadData,
        deletePlanLeadData,
        errorDeletePlanLead,
        addPlanLeadData,
        errorAddPlanLead,
        errorUpdatePlanLead,
        deleteMany,
        insertData,
        updateData,
        deleteData,
    } = useSelector(
        (state) => ({
            planLeadData: state.Production.planLeadData,
            updatePlanLeadData: state.Production.updatePlanLeadData,
            deletePlanLeadData: state.Production.deletePlanLeadData,
            errorDeletePlanLead: state.Production.errorDeletePlanLead,
            addPlanLeadData: state.Production.addPlanLeadData,
            errorAddPlanLead: state.Production.errorAddPlanLead,
            errorUpdatePlanLead: state.Production.errorUpdatePlanLead,
            deleteMany: state.Processings.deleteMany,
            insertData: state.Materials.insertData,
            updateData: state.Materials.updateData,
            deleteData: state.Materials.deleteData,
        }),
        shallowEqual
    );

    const validationSchema = Yup.object({
        time: Yup.string().required("Giá trị này là bắt buộc"),
        materialPrimary: Yup.string().required("Giá trị này là bắt buộc"),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            time: "",
            materialPrimary: "",
            productId: productId,
            type: "material-primary",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            const formattedValues = {
                ...values,
                time: values.time ? values.time.toISOString() : "",
            };

            if (isEditMode && rowData) {
                dispatch(
                    updatePlanLead({ id: rowData.id, data: formattedValues })
                );
            } else {
                dispatch(setPlanLead(formattedValues));
            }
            setShowNewPlanFields(false);
            setIsEditMode(false);
            formik.resetForm();
        },
    });

    useEffect(() => {
        if (isShow && productId) {
            dispatch(
                getPlanLead({
                    page: (first + rows) / rows,
                    limit: rows,
                    productId,
                    // type: "material-primary",
                })
            );
        }
    }, [
        dispatch,
        isShow,
        productId,
        first,
        rows,
        insertData,
        updateData,
        deleteData,
    ]);

    useEffect(() => {
        if (
            deletePlanLeadData ||
            updatePlanLeadData ||
            addPlanLeadData ||
            deleteMany
        ) {
            dispatch(
                getPlanLead({
                    page: (first + rows) / rows,
                    limit: rows,
                    productId,
                    // type: "material-primary",
                })
            );
            dispatch(setDataNull2());
        }
    }, [
        deletePlanLeadData,
        updatePlanLeadData,
        addPlanLeadData,
        dispatch,
        deleteMany,
        first,
        rows,
    ]);

    const handleDelete = (rowData) => {
        setModalDelete(true);
        setRowData(rowData);
    };

    const acceptDelete = () => {
        if (rowData && rowData !== undefined) {
            const id = rowData.id;
            if (id !== undefined) {
                dispatch(deleteMaterial({ id }));
            }
            setModalDelete(false);
        }
    };

    useEffect(() => {
        if (addPlanLeadData) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Thêm thành công",
                life: 3000,
            });
            dispatch(setDataNull2());
        }
    }, [dispatch, addPlanLeadData]);

    useEffect(() => {
        if (errorAddPlanLead) {
            toast.current?.show({
                severity: "error",
                summary: "Thất bại",
                detail: errorAddPlanLead?.response?.data?.message,
                life: 3000,
            });
            // dispatch(setDataNull2());
        }
    }, [dispatch, errorAddPlanLead]);

    useEffect(() => {
        if (updatePlanLeadData) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Sửa thành công",
                life: 3000,
            });
            dispatch(setDataNull2());
        }
    }, [dispatch, updatePlanLeadData]);

    useEffect(() => {
        if (errorUpdatePlanLead) {
            toast.current?.show({
                severity: "error",
                summary: "Thất bại",
                detail: errorUpdatePlanLead?.response?.data?.message,
                life: 3000,
            });
            // dispatch(setDataNull2());
        }
    }, [dispatch, errorUpdatePlanLead]);

    useEffect(() => {
        if (deletePlanLeadData) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Xóa thành công",
                life: 3000,
            });
            dispatch(setDataNull2());
        }
    }, [dispatch, deletePlanLeadData]);

    useEffect(() => {
        if (errorDeletePlanLead) {
            toast.current?.show({
                severity: "error",
                summary: "Thất bại",
                detail: errorDeletePlanLead.response.data.message,
                life: 3000,
            });
            // dispatch(setDataNull2());
        }
    }, [dispatch, errorDeletePlanLead]);

    const actionBodyTemplate = (rowData) => {
        return (
            <ActionMenu
                onDelete={() => handleDelete(rowData)}
                onEdit={() => handleEdit(rowData)}
            />
        );
    };
    const handleSelectionChange = (e) => {
        const selected = e.value || [];

        // Gộp các phần tử không bị xóa với phần tử vừa chọn
        const updatedSelection = [...selected];

        // Loại bỏ phần tử trùng lặp
        const uniqueSelection = Array.from(
            new Map(updatedSelection.map((item) => [item.id, item])).values()
        );

        setSelectedProducts(uniqueSelection);
    };

    const handleEdit = (rowData) => {
        setRowData(rowData);
        setOpenModalUpdate(true);
    };
    const handleDeleteMany = () => {
        if (selectedProducts?.length > 0) {
            dispatch(
                deleteManyRequest({
                    type: "material",
                    ids: selectedProducts?.map((item) => item.id),
                })
            );

            setSelectedProducts([]);
        }
    };
    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    return (
        <Dialog
            header={
                <div className="flex justify-content-between align-items-center">
                    <p>Kế hoạch sản xuất Leadtime vật tư chính</p>
                    {selectedProducts?.length > 0 && (
                        <Button
                            label="Xóa"
                            style={{ height: "35px" }}
                            onClick={() => handleDeleteMany()}
                        />
                    )}
                </div>
            }
            visible={isShow}
            style={{ width: "70vw" }}
            className="responsive-dialog"
            onHide={() => {
                formik.resetForm();
                setIsEditMode(false);
                setShowNewPlanFields(false);
                dispatch(setDataNull2());
                setChecked(false);
                onHide();
            }}
            footer={
                false
                // <div>
                //     <Button
                //         label="Hủy"
                //         severity="secondary"
                //         className="p-button-text"
                //         onClick={() => {
                //             formik.resetForm();
                //             setIsEditMode(false);
                //             setShowNewPlanFields(false);
                //             onHide();
                //             dispatch(setDataNull2());
                //         }}
                //     />
                //     <Button
                //         label="Lưu"
                //         type="button"
                //         onClick={() => formik.handleSubmit()}
                //     />
                // </div>
            }
        >
            <Toast ref={toast} />
            <DataTable
                emptyMessage="Không có dữ liệu"
                value={planLeadData?.data?.items || []}
                tableStyle={{ minWidth: "20rem" }}
                onSelectionChange={handleSelectionChange}
                selectionMode="checkbox"
                selection={selectedProducts || []}
            >
                <Column selectionMode="multiple"></Column>

                <Column
                    header="YCVT số BRAVO"
                    field="materialRequestNumber"
                    style={{ width: "30%", minWidth: "120px" }}
                ></Column>
                <Column
                    header="YCVT số PR"
                    field="materialRequestNumberPr"
                    style={{ width: "30%", minWidth: "120px" }}
                ></Column>
                <Column
                    field="code"
                    header="Code VT"
                    style={{ width: "30%", height: "40px" }}
                ></Column>
                <Column
                    field="name"
                    header="Tên VT"
                    style={{ width: "60%", height: "40px" }}
                ></Column>
                <Column
                    field="unit"
                    header="ĐVT"
                    style={{ width: "40%", height: "40px" }}
                ></Column>
                <Column
                    field="quantity"
                    header="SL"
                    style={{ width: "40%", height: "40px" }}
                    body={(rowData) => formatQuantity(rowData.quantity)}
                ></Column>
                <Column
                    field="expectedArrivalDate"
                    header="Ngày dự kiến về"
                    style={{ width: "40%", height: "40px" }}
                    body={(rowData) => formatDate(rowData.expectedArrivalDate)}
                ></Column>
                <Column
                    field="materialPrimary"
                    header="SL kế hoạch"
                    style={{ width: "20%" }}
                    alignHeader={"center"}
                    align={"center"}
                ></Column>
                <Column
                    field="description"
                    header="Ghi chú"
                    style={{ width: "60%", minWidth: "150px" }}
                    alignHeader={"center"}
                    align={"center"}
                ></Column>
                <Column
                    field="status"
                    header="Trạng thái"
                    style={{ width: "20%" }}
                    alignHeader={"center"}
                    align={"center"}
                    // body={(rowData) => (
                    //     <Checkbox checked={rowData.finishMaterial} />
                    // )}
                ></Column>
                <Column
                    field="action"
                    body={actionBodyTemplate}
                    style={{ minWidth: "100px", padding: "0", height: "50px" }}
                />
            </DataTable>
            <div className="card">
                <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={planLeadData?.data?.totalItems}
                    rowsPerPageOptions={[10, 20, 30, 100, 200, 500]}
                    onPageChange={onPageChange}
                />
            </div>
            <ModelDelete
                visible={modalDelete}
                setVisible={setModalDelete}
                accept={acceptDelete}
            />
            {showNewPlanFields && (
                <div className="mt-2 flex justify-content-between gap-2">
                    <div
                        className="flex flex-column"
                        style={{ width: "200px" }}
                    >
                        <InputText
                            id="materialRequestNumber"
                            name="materialRequestNumber"
                            value={formik.values.materialRequestNumber || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Nhập YCVT"
                        />
                    </div>
                    <div
                        className="flex flex-column"
                        style={{ width: "200px" }}
                    >
                        <InputText
                            id="code"
                            name="code"
                            value={formik.values.code || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Nhập Code VT"
                        />
                    </div>
                    <div
                        className="flex flex-column"
                        style={{ width: "400px" }}
                    >
                        <InputText
                            id="name"
                            name="name"
                            value={formik.values.name || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Tên VT"
                        />
                    </div>
                    <div className="flex flex-column" style={{ width: "10%" }}>
                        <InputText
                            id="unit"
                            name="unit"
                            value={formik.values.unit || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="ĐVT"
                        />
                    </div>
                    <div className="flex flex-column" style={{ width: "10%" }}>
                        <InputText
                            id="quantity"
                            name="quantity"
                            value={formik.values.quantity || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="SL"
                        />
                    </div>
                    <div className="flex flex-column" style={{ width: "48%" }}>
                        <Calendar
                            id="time"
                            name="time"
                            dateFormat="dd/mm/yy"
                            value={formik.values.time}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Chọn ngày"
                        />
                        {formik.touched.time && formik.errors.time ? (
                            <small className="p-error">
                                {formik.errors.time}
                            </small>
                        ) : null}
                    </div>
                    <div className="flex flex-column" style={{ width: "18%" }}>
                        <InputText
                            id="materialPrimary"
                            name="materialPrimary"
                            value={formik.values.materialPrimary || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Nhập số lượng KH"
                        />
                        {formik.touched.materialPrimary &&
                        formik.errors.materialPrimary ? (
                            <small className="p-error">
                                {formik.errors.materialPrimary}
                            </small>
                        ) : null}
                    </div>
                    <div className="flex flex-column" style={{ width: "28%" }}>
                        <InputText
                            id="note"
                            name="note"
                            value={formik.values.note}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Ghi chú"
                        />
                    </div>
                    <div
                        className="flex align-items-center"
                        style={{ width: "36%" }}
                    >
                        <Checkbox
                            id="finishMaterial"
                            name="finishMaterial"
                            checked={formik.values.finishMaterial}
                            onChange={(e) =>
                                formik.setFieldValue(
                                    "finishMaterial",
                                    e.checked
                                )
                            }
                        />
                    </div>
                </div>
            )}
            {/* {!showNewPlanFields && (
                <Button
                    type="button"
                    style={{ marginTop: "1rem" }}
                    label="Thêm dòng"
                    onClick={() => setShowNewPlanFields(true)}
                />
            )} */}
            <ModalMaterials
                visible={openModalUpdate}
                onHide={() => setOpenModalUpdate(false)}
                rowData={rowData}
                toast={toast}
            />
        </Dialog>
    );
}

export default ModalShowPlanLead;
